"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
/* CHANNEL */
var Channel = {
    /* CLAMP */
    min: {
        r: 0,
        g: 0,
        b: 0,
        s: 0,
        l: 0,
        a: 0
    },
    max: {
        r: 255,
        g: 255,
        b: 255,
        h: 360,
        s: 100,
        l: 100,
        a: 1
    },
    clamp: {
        r: function (r) { return r >= 255 ? 255 : (r < 0 ? 0 : r); },
        g: function (g) { return g >= 255 ? 255 : (g < 0 ? 0 : g); },
        b: function (b) { return b >= 255 ? 255 : (b < 0 ? 0 : b); },
        h: function (h) { return h % 360; },
        s: function (s) { return s >= 100 ? 100 : (s < 0 ? 0 : s); },
        l: function (l) { return l >= 100 ? 100 : (l < 0 ? 0 : l); },
        a: function (a) { return a >= 1 ? 1 : (a < 0 ? 0 : a); }
    },
    /* CONVERSION */
    //SOURCE: https://planetcalc.com/7779
    toLinear: function (c) {
        var n = c / 255;
        return c > .03928 ? Math.pow(((n + .055) / 1.055), 2.4) : n / 12.92;
    },
    //SOURCE: https://gist.github.com/mjackson/5311256
    hue2rgb: function (p, q, t) {
        if (t < 0)
            t += 1;
        if (t > 1)
            t -= 1;
        if (t < 1 / 6)
            return p + (q - p) * 6 * t;
        if (t < 1 / 2)
            return q;
        if (t < 2 / 3)
            return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    },
    hsl2rgb: function (_a, channel) {
        var h = _a.h, s = _a.s, l = _a.l;
        if (s === 100)
            return l * 2.55; // Achromatic
        h /= 360;
        s /= 100;
        l /= 100;
        var q = (l < .5) ? l * (1 + s) : (l + s) - (l * s), p = 2 * l - q;
        switch (channel) {
            case 'r': return Channel.hue2rgb(p, q, h + 1 / 3) * 255;
            case 'g': return Channel.hue2rgb(p, q, h) * 255;
            case 'b': return Channel.hue2rgb(p, q, h - 1 / 3) * 255;
        }
    },
    rgb2hsl: function (_a, channel) {
        var r = _a.r, g = _a.g, b = _a.b;
        r /= 255;
        g /= 255;
        b /= 255;
        var max = Math.max(r, g, b), min = Math.min(r, g, b), l = (max + min) / 2;
        if (channel === 'l')
            return l * 100;
        if (max === min)
            return 0; // Achromatic
        var d = max - min, s = (l > .5) ? d / (2 - max - min) : d / (max + min);
        if (channel === 's')
            return s * 100;
        switch (max) {
            case r: return ((g - b) / d + (g < b ? 6 : 0)) * 60;
            case g: return ((b - r) / d + 2) * 60;
            case b: return ((r - g) / d + 4) * 60;
            default: return -1; //TSC: TypeScript is stupid and complains if there isn't this useless default statement
        }
    }
};
/* EXPORT */
exports.default = Channel;



//////////////////
// WEBPACK FOOTER
// ./~/khroma/dist/utils/channel.js
// module id = 2195
// module chunks = 0